module.exports = __webpack_public_path__ + "static/img/5.4f50b75.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/5.png
// module id = t8m9
// module chunks = 0